import React, { useEffect, useState } from "react";
import { useRemoteRenderContext } from "../../../../classes/contexts/RemoteRenderContext";
import { PLANNING_STATES } from "../../../../classes/enums/PlanningStateEnum";
import Button from "../../../../components/button/Button";
import LabeledSelect from "../../../../components/select/LabeledSelect";
import "../../vertebraManagementPopups/VertebraManagement.css";

const RemoveLandmark = ({ onClose }) => {
  const { client: renderClient } = useRemoteRenderContext();
  const [existingLandmarks, setExistingLandmarks] = useState([]);
  const [selectedLandmark, setSelectedLandmark] = useState("");
  const [selectedPointId, setSelectedPointId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchExistingLandmarks = async () => {
      try {
        setIsLoading(true);
        const data = await renderClient.getDeletableLandmarks(
          PLANNING_STATES.VALIDATE
        );
        setExistingLandmarks(data);

        if (data && data.length > 0) {
          setSelectedLandmark(data[0][0]); // landmark name
          setSelectedPointId(data[0][1]); // point ID
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchExistingLandmarks();
  }, [renderClient]);

  // Generate landmark items for dropdown
  const landmarkItems = existingLandmarks.map(([landmarkName, pointId]) => ({
    value: `${landmarkName}|${pointId}`, // Combine name and ID
    label: landmarkName,
  }));

  const handleLandmarkChange = event => {
    const value = event.target.value;
    const [landmarkName, pointId] = value.split("|");
    setSelectedLandmark(landmarkName);
    setSelectedPointId(parseInt(pointId, 10));
  };

  const handleRemoveLandmark = React.useCallback(async () => {
    if (!selectedLandmark || selectedPointId === null) {
      return;
    }

    try {
      await renderClient.removeLandmark(
        PLANNING_STATES.VALIDATE,
        selectedLandmark,
        selectedPointId
      );
      onClose?.();
    } catch (error) {}
  }, [selectedLandmark, selectedPointId, renderClient, onClose]);

  if (isLoading) {
    return (
      <div className="vertebra-management-container">
        <div>Loading existing landmarks...</div>
      </div>
    );
  }

  if (!landmarkItems.length) {
    return (
      <div className="vertebra-management-container">
        <div>No landmarks to remove</div>
      </div>
    );
  }

  const isSingleLandmark = landmarkItems.length === 1;

  return (
    <div className="vertebra-management-container">
      <LabeledSelect
        label="Select Landmark"
        items={landmarkItems}
        selectedItem={`${selectedLandmark}|${selectedPointId}`}
        onChange={handleLandmarkChange}
        disable={isLoading || isSingleLandmark}
      />
      <div className="vertebra-management-actions">
        <Button
          className="App-button"
          onClick={handleRemoveLandmark}
          disabled={!selectedLandmark}
          value="Remove Landmark"
        />
      </div>
    </div>
  );
};

export default RemoveLandmark;
